export enum OnCompleteAction {
	Nothing,
	Delete,
	Move,
}
